<div
    class="relative grow overflow-y-auto p-4"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': (loading$ | async) && applications.length > 0}"
>
    @if ((loading$ | async) && applications.length > 0) {
        <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-semibold">Upload potpisanih ugovora</h2>
        <button class="valben-button text-lg" (click)="back()">Natrag</button>
    </div>

    @if (applications.length === 0) {
        <div class="text-lg">
            Nema djelatnika sa statusom Generirani ugovori.
        </div>
    }

    @if (applications.length > 0) {
        <div class="flex flex-wrap gap-2 mb-4">
            @for (application of applications; track application.masterId) {
            <button
                class="valben-button text-base"
                [ngClass]="selectedApplication?.masterId === application.masterId
                    ? 'valben-button--selected' : 'valben-button--quiet'"
                (click)="selectApplication(application)"
            >
                {{ application.name }} {{ application.surname }} ({{ application.mbrad }})
            </button>
            }
        </div>
    }

    @for (form of uploadForm; track form.id) {
        <div class="border border-gray-300 rounded-md p-4">
            <p class="text-xl font-semibold mb-1">
                {{ selectedApplication!.name }} {{ selectedApplication!.surname }} ({{ selectedApplication!.mbrad }})
            </p>
            <p class="text-sm text-valamardarkgray mb-4">{{ selectedApplication!.email }}</p>

            <div class="flex flex-col gap-4">
                <valben-file-input
                    key="rentalAgreement"
                    [itemObservable]="contractItemObservable"
                    [update]="updateRental"
                    fileType="application/pdf"
                    [error]="false"
                    [isKng]="true"
                    [previewFile]="true"
                    [optional]="false"
                    title="Ugovor o najmu">
                </valben-file-input>

                <valben-file-input
                    key="subrentalAgreement"
                    [itemObservable]="contractItemObservable"
                    [update]="updateSubrental"
                    fileType="application/pdf"
                    [error]="false"
                    [isKng]="true"
                    [previewFile]="true"
                    [optional]="false"
                    title="Ugovor o podnajmu">
                </valben-file-input>
            </div>

            <div class="flex justify-end mt-4">
                <button class="valben-button text-lg" (click)="saveContracts(selectedApplication!)">
                    Spremi ugovore
                </button>
            </div>
        </div>
    }
</div>
